export const environment = {
    production: false,
    apiUrl: 'https://libya-test.hidaya.me',
    libyanaDaily: "ae483690-905c-11ef-831b-6572c93a15e0",
    libyanaWeekly: "b87f5b10-905c-11ef-a5af-d1f39c817705",
    madarWeekly: "d029ad50-905c-11ef-a87a-1bbfb56871ea",
};
